import {ShopItemRESTHelper} from "classes/api";

export default {
    created() {

        // if( this.shopItemId ) {
        //     let itemHelper = new ShopItemRESTHelper(this.shopItemId)
        //     itemHelper.isOfProduct(window.FlyerlineConfig.product_key)
        //         .then(() => this.updateItem = this.shopItemId)
        //         .catch( () => {
        //             console.log("shop item not valid for product.")
        //         })
        // }

    },
    props: {
        shopItemId: {
            type: Number,
            required: false
        }
    },
    data() {

        return {
            updateItem: null
        }

    },
    methods: {
        updateBasketItem: function (data) {
            if( this.updateItem )
            {
                let itemRESTHelper = new ShopItemRESTHelper(this.updateItem)
                return itemRESTHelper.updateItem( data )
            }
        }
    }
}